var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("说明】您可以在这里填写您所在的课题组研究方向，并添加与之相关的图片，范例如下：")]),_vm._v(" "),_c('p',[_vm._v("XXX课题组现阶段主要有两个大的研究方向：")]),_vm._v(" "),_c('p',[_vm._v("(1) XXXX技术与机理研究")]),_vm._v(" "),_c('p',[_vm._v("(2) XX的XXX理论与技术")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1faadee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/shuomingcard/shuomingcard.vue
// module id = null
// module chunks = 